import React from 'react';
import { Calendar, Hand, ShoppingCart, UtensilsCrossed } from 'lucide-react';
export function BenefitStrip() {
  const benefits = [{
    icon: <Calendar className="w-3.5 h-3.5 md:w-5 md:h-5" data-id="element-19" data-mp="30gdst0rvi7i5" />,
    title: 'ORGANIZÁ TODA LA SEMANA',
    desc: 'Planificá menús completos sin vueltas ni complicaciones.'
  }, {
    icon: <Hand className="w-3.5 h-3.5 md:w-5 md:h-5" data-id="element-20" data-mp="2rexq7f7av9oh" />,
    title: 'RESOLVÉ SIN IMPROVISAR',
    desc: 'Tené siempre opciones claras para cada día.'
  }, {
    icon: <ShoppingCart className="w-3.5 h-3.5 md:w-5 md:h-5" data-id="element-21" data-mp="3j5tuhrfao605" />,
    title: 'APROVECHÁ MEJOR LAS COMPRAS',
    desc: 'Comprá inteligente, evitá desperdicios y ahorrá dinero.'
  }, {
    icon: <UtensilsCrossed className="w-3.5 h-3.5 md:w-5 md:h-5" data-id="element-22" data-mp="3acgrtxrfhq0v" />,
    title: 'VIANDAS QUE SÍ SE SOSTIENEN',
    desc: 'Recetas prácticas, ricas y aprobadas por los chicos.'
  }];
  return <section className="bg-cosmic-deep pt-1 pb-5 md:pt-2 md:pb-8 px-4 relative" data-id="element-23" data-mp="6oorvh1asrfn">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-64 bg-purple-600/10 rounded-full blur-3xl pointer-events-none" data-id="element-24" data-mp="4s8t2w2s964d"></div>
      <div className="max-w-4xl mx-auto relative" data-id="element-25" data-mp="ou074tqwv9i">
        <div className="bg-white/5 backdrop-blur-sm rounded-xl border border-gold/20 shadow-[0_8px_40px_rgba(0,0,0,0.3)] p-2.5 md:p-4" data-id="element-26" data-mp="eil9cc3ked4p">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3" data-id="element-27" data-mp="9qa9tacqktco">
            {benefits.map((b, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-28" data-mp="oic66kfll47y" data-mpi={i}>
                <div className="w-7 h-7 md:w-9 md:h-9 rounded-full bg-gradient-to-br from-[#1a0533] to-[#2D0A6B] flex items-center justify-center text-gold mb-1 shadow-lg border border-white/10" data-id="element-29" data-mp="jh4xmj5ms108">
                  {b.icon}
                </div>
                <h3 className="font-display font-bold text-white text-[9px] md:text-xs mb-0.5 leading-tight" data-id="element-30" data-mp="2z8am8jkpjour">
                  {b.title}
                </h3>
                <p className="text-white/70 text-[8px] md:text-[11px] leading-snug" data-id="element-31" data-mp="2ubagk9rrso46">
                  {b.desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}